import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../lib/AuthContext'
import logo from '../assets/logo.jpg'
import '../styles/Auth.css'

export default function Auth() {
  const [tab, setTab] = useState('login')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')
  const [success, setSuccess] = useState('')
  const [form, setForm] = useState({ email: '', password: '', name: '', handicap: '' })
  const { signIn, signUp, resetPassword } = useAuth()
  const navigate = useNavigate()

  const update = (k, v) => setForm(f => ({ ...f, [k]: v }))

  const handleLogin = async () => {
    setError(''); setLoading(true)
    const { error } = await signIn(form.email, form.password)
    if (error) setError(error.message)
    else navigate('/dashboard')
    setLoading(false)
  }

  const handleRegister = async () => {
    if (!form.name) return setError('Please enter your name')
    if (!form.email) return setError('Please enter your email')
    if (!form.password || form.password.length < 6) return setError('Password must be at least 6 characters')
    setError(''); setLoading(true)
    const { error } = await signUp(form.email, form.password, form.name, form.handicap)
    if (error) setError(error.message)
    else setSuccess('Check your email to confirm your account, then sign in.')
    setLoading(false)
  }

  const handleReset = async () => {
    if (!form.email) return setError('Please enter your email address')
    setError(''); setLoading(true)
    const { error } = await resetPassword(form.email)
    if (error) setError(error.message)
    else setSuccess('Password reset email sent — check your inbox.')
    setLoading(false)
  }

  const handleKey = (e, fn) => { if (e.key === 'Enter') fn() }

  return (
    <div className="auth-screen">
      <div className="auth-bg-glow auth-bg-glow--top" />
      <div className="auth-bg-glow auth-bg-glow--bottom" />

      <div className="brand-lockup">
        <img src={logo} alt="Harry Shaw Golf" className="brand-logo-img" />
        <div className="brand-app-name">Round Analyser</div>
        <div className="brand-tagline">Track. Analyse. Improve.</div>
      </div>

      <div className="auth-card">
        {tab !== 'forgot' && (
          <div className="auth-tabs">
  <button className="auth-tab active">Sign In</button>
</div>
        )}

        {error && <div className="error-msg">{error}</div>}
        {success && <div className="success-msg">{success}</div>}

        {tab === 'login' && (
          <>
            <div className="form-group">
              <label className="form-label">Email</label>
              <input className="form-input" type="email" placeholder="your@email.com" value={form.email} onChange={e => update('email', e.target.value)} onKeyDown={e => handleKey(e, handleLogin)} />
            </div>
            <div className="form-group">
              <label className="form-label">Password</label>
              <input className="form-input" type="password" placeholder="••••••••" value={form.password} onChange={e => update('password', e.target.value)} onKeyDown={e => handleKey(e, handleLogin)} />
            </div>
            <button className="btn-primary" onClick={handleLogin} disabled={loading}>{loading ? 'Signing in...' : 'Sign In'}</button>
            <p className="auth-forgot" onClick={() => { setTab('forgot'); setError(''); setSuccess('') }}>Forgot your password?</p>
          </>
        )}

        {tab === 'register' && (
          <>
            <div className="form-group">
              <label className="form-label">Name</label>
              <input className="form-input" type="text" placeholder="John Smith" value={form.name} onChange={e => update('name', e.target.value)} />
            </div>
            <div className="form-group">
              <label className="form-label">Email</label>
              <input className="form-input" type="email" placeholder="your@email.com" value={form.email} onChange={e => update('email', e.target.value)} />
            </div>
            <div className="form-group">
              <label className="form-label">Current Handicap</label>
              <input className="form-input" type="number" placeholder="e.g. 14" value={form.handicap} onChange={e => update('handicap', e.target.value)} />
            </div>
            <div className="form-group">
              <label className="form-label">Password</label>
              <input className="form-input" type="password" placeholder="Min. 6 characters" value={form.password} onChange={e => update('password', e.target.value)} onKeyDown={e => handleKey(e, handleRegister)} />
            </div>
            <button className="btn-primary" onClick={handleRegister} disabled={loading}>{loading ? 'Creating account...' : 'Create Account'}</button>
          </>
        )}

        {tab === 'forgot' && (
          <>
            <div className="auth-back" onClick={() => { setTab('login'); setError(''); setSuccess('') }}>← Back to sign in</div>
            <h3 className="forgot-title">Reset Password</h3>
            <p className="forgot-sub">Enter your email and we'll send you a reset link.</p>
            <div className="form-group">
              <label className="form-label">Email</label>
              <input className="form-input" type="email" placeholder="your@email.com" value={form.email} onChange={e => update('email', e.target.value)} onKeyDown={e => handleKey(e, handleReset)} />
            </div>
            <button className="btn-primary" onClick={handleReset} disabled={loading}>{loading ? 'Sending...' : 'Send Reset Link'}</button>
          </>
        )}
      </div>
    </div>
  )
}
